"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRootDomain = exports.resetGetRootDomain = exports.makeGetRootDomainCached = void 0;
const utils_1 = require("./utils");
const cookie_config_1 = require("./cookie-config");
const cookie_1 = require("./cookie");
const WebApi_1 = require("./WebApi");
const { TEST_COOKIE_KEY } = cookie_config_1.cookieConfig;
// Exported for testing
function makeGetRootDomainCached() {
    let cache;
    return () => {
        if (!WebApi_1.isBrowser) {
            return '';
        }
        if (cache) {
            return cache;
        }
        const parts = `${window.location.hostname}`.split('.');
        const testValue = (0, utils_1.randomString)();
        let domain = window.location.hostname;
        let test = '';
        for (let i = 0; i < parts.length; i += 1) {
            try {
                domain = parts.slice(-(i + 1)).join('.');
                (0, cookie_1.writeCookie)(TEST_COOKIE_KEY, testValue, domain, 1);
                test = (0, cookie_1.readCookie)(TEST_COOKIE_KEY);
                (0, cookie_1.deleteCookie)(TEST_COOKIE_KEY, domain);
                if (test === testValue) {
                    break;
                }
                // eslint-disable-next-line no-empty
            }
            catch (e) {
            }
        }
        cache = domain;
        return domain;
    };
}
exports.makeGetRootDomainCached = makeGetRootDomainCached;
const resetGetRootDomain = () => {
    exports.getRootDomain = makeGetRootDomainCached();
};
exports.resetGetRootDomain = resetGetRootDomain;
/**
 * Function for getting the highest cookie domain where a cookie can be placed.
 * This is done by trying to set and then read back a cookie at the tld, and
 * then working downwards.
 *
 * This function is memoized as `window.location.hostname` is supposed to be
 * immutable during the lifetime of the code.
 *
 * @returns {string} the top domain for setting cookies. Example: aftonbladet.se
 */
exports.getRootDomain = makeGetRootDomainCached();
//# sourceMappingURL=getRootDomain.js.map